import { createContext, useContext } from 'react';

import { IDetailedCompany } from '~/@store/companies';

export const CompanyDetailContext = createContext<IDetailedCompany>({} as IDetailedCompany);

export const useCompanyDetailContext = () => useContext(CompanyDetailContext);
